import React, { useEffect, useState } from 'react';
import { fileAccessApi } from '../../api/fileAccessApi';
import { resolveBackendAssetUrl } from '../../utils/apiBaseUrl';

interface MediaImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  fallbackText?: string;
}

export const MediaImage: React.FC<MediaImageProps> = ({
  src,
  alt,
  className = '',
  fallbackClassName = '',
  fallbackText = 'Không có ảnh',
}) => {
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadImage = async () => {
      if (!src) {
        setLoading(false);
        setFailed(true);
        return;
      }

      try {
        setLoading(true);
        setFailed(false);

        if (src.startsWith('http://') || src.startsWith('https://')) {
          if (!cancelled) setImageUrl(src);
        } else if (src.startsWith('s3://')) {
          const secureUrl = await fileAccessApi.getSecureFileUrl(src);
          if (!cancelled) setImageUrl(secureUrl);
        } else if (!cancelled) {
          setImageUrl(resolveBackendAssetUrl(src));
        }
      } catch {
        if (!cancelled) setFailed(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadImage();

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (loading) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center ${fallbackClassName || className}`}>
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (failed || !imageUrl) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center text-gray-400 text-sm ${fallbackClassName || className}`}>
        {fallbackText}
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};
